import { Currency } from '@/modules/common';
import { OrganizationSummaryResponse } from '@/modules/common/types/dto/response/organization-summary.response';
import { OrganizationSummary } from '@/modules/common/types/organization-summary';

/**
 * Maps organization defaults response from API to application domain model.
 */
export const mapOrganizationSummaryFromResponse = (
  response: OrganizationSummaryResponse
): OrganizationSummary => {
  return {
    id: response.id,
    name: response.name,
    timezone: response.timezone,
    defaultCurrency: response.currency
      ? new Currency(response.currency.code, response.currency.displayName)
      : null,
  };
};
